import { SelectInterface } from '../../interfaces/Select';
import { FormSelect } from '../../../../component/input/InputStyle';
import FormLabel from '../../../../component/input/FormLabel.component';
import MenuItem from '@material-ui/core/MenuItem';
import { ChangeEvent, useState } from 'react';

export default function Form({ title, handleSubmitForm, initialValues, disabled, required, listItem }: SelectInterface<String>) {

    const [flags, setFlags] = useState<String>('');

    const handleChange = (event: ChangeEvent<{ name?: string, value: unknown }>) => {
        const { value } = event.target;
        setFlags(String(value));
        handleSubmitForm(String(value));
    }

    return (
        <FormLabel title={title} sm={6} md={4} lg={2} required={required}>
            <FormSelect
                displayEmpty={true}
                value={flags || initialValues || ''}
                disabled={disabled}
                onChange={handleChange}
                defaultValue="Todas"
            >
                <MenuItem value="" disabled>Selecione...</MenuItem>
                {listItem.map((item, index: number) => {
                    return <MenuItem value={String(item || index)} key={index}>{item}
                    </MenuItem>
                })}
            </FormSelect>
        </FormLabel>
    )
}
